import React, { Component } from "react";
import TimeDiff from "../../helpers/TimeDiff";

class AllAudioTable extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <table className="a-table">
        <thead>
          <tr>
            <td>Message Title</td>
            <td>Message</td>
            <td>Time Posted</td>
            <td></td>
            <td></td>
          </tr>
        </thead>
        <tbody>
          {this.props.posts.length > 0 &&
            this.props.posts.map(p => (
              <tr key={p.post_id} id={`row${p.post_id}`} >
                <td style={{ textAlign: "left" }}>
                  {
                    p.post_title}
                </td>
                <td>
                  <audio controls>
                    <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/ogg" />
                    <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/flac" />
                    <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/mp3" />
                    <source src={`${this.props.root}public/audio/${p.audio}`} type="audio/mpeg" />
                  </audio>
                </td>
                <td>
                  {" "}
                  <TimeDiff date={p.created_at} />{" "}
                </td>
                <td>
                    <button
                      className={`a-table-retrieve`}
                      data-id={p.post_id}
                      data-title={p.post_title}
                      data-post={p.main_post}
                      data-audio={p.audio}
                      onClick={this.props.startUpdate}
                    >
                      {`Update`}
                    </button>
                </td>
                <td>
                  <button
                    className={`a-table-delete`}
                    data-id={p.post_id}
                    onClick={this.props.postDelete}
                  >
                    {`Delete`}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    );
  }
}

export default AllAudioTable;
